__webpack_require__.p = "/krust/timetable/";